var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarHoursClock = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "url(#paint0_linear_54868_146814)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.15 5.45898C10.8564 5.45898 9.59183 5.84259 8.51623 6.56128C7.44063 7.27997 6.6023 8.30148 6.10725 9.49662C5.61221 10.6918 5.48268 12.0069 5.73505 13.2756C5.98743 14.5444 6.61036 15.7098 7.52508 16.6245C8.43981 17.5393 9.60523 18.1622 10.874 18.4146C12.1427 18.6669 13.4578 18.5374 14.653 18.0424C15.8481 17.5473 16.8696 16.709 17.5883 15.6334C18.307 14.5578 18.6906 13.2932 18.6906 11.9996C18.6888 10.2655 17.9991 8.60292 16.7729 7.37671C15.5467 6.1505 13.8841 5.46082 12.15 5.45898ZM15.6719 12.5027H13.3644L15.0216 14.1593C15.0683 14.206 15.1054 14.2615 15.1307 14.3226C15.156 14.3837 15.169 14.4491 15.169 14.5152C15.169 14.5813 15.156 14.6468 15.1307 14.7079C15.1054 14.769 15.0683 14.8245 15.0216 14.8712C14.9748 14.9179 14.9193 14.955 14.8583 14.9803C14.7972 15.0056 14.7317 15.0186 14.6656 15.0186C14.5995 15.0186 14.5341 15.0056 14.473 14.9803C14.4119 14.955 14.3564 14.9179 14.3097 14.8712L11.794 12.3556C11.7236 12.2852 11.6756 12.1955 11.6562 12.0979C11.6367 12.0002 11.6467 11.899 11.6848 11.807C11.7229 11.715 11.7875 11.6364 11.8703 11.5812C11.9531 11.5259 12.0504 11.4964 12.15 11.4965H15.6719C15.8053 11.4965 15.9333 11.5495 16.0276 11.6438C16.122 11.7382 16.175 11.8662 16.175 11.9996C16.175 12.133 16.122 12.261 16.0276 12.3554C15.9333 12.4497 15.8053 12.5027 15.6719 12.5027Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_54868_146814",
  x1: 6.5,
  y1: 1,
  x2: 16,
  y2: 23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1EAED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A0C8FF"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarHoursClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_hours_clock.e1639d9a2b882a92f57caa603577fabc.svg";